<template>
  <el-dialog
    :title="$t('message.tips')"
    :visible.sync="show"
    @close="close"
    :ripple="false"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="500px"
  >
    <div
      v-html="$t('message.question_tips_content', [courseTitle])"
      class="question-tips-content"
    ></div>
    <span slot="footer" :class="`footer-btn qt-footer-btn-${$i18n.locale}`">
      <el-button type="primary" @click="toQuestionnaire">{{
        $t("message.question_tips_btn1")
      }}</el-button>
      <el-button type="primary" @click="$emit('handleContinue')">{{
        $t("message.question_tips_btn2")
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { Base64 } from "js-base64";
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    id: [String, Number],
    courseTitle: String,
    showBack: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close");
    },
    toQuestionnaire() {
      if (this.$store.state.isPreview) return false;
      const code = Base64.encode(`id=${this.id}&type=user`);
      this.$router.push({
        path: "/question",
        query: {
          code: code,
          back: this.showBack ? 1 : 0,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__wrapper {
  //   display: flex;
  //   flex-direction: row;
  //   align-items: center;
  //   justify-content: center;
}
/deep/.el-dialog {
  border-radius: 10px;
  max-width: 95%;
  margin-top: 20vh !important;
  //   max-height: 100%;
  //   margin: auto !important;
  //   overflow: auto;
  .el-dialog__header {
    text-align: center;
    font-weight: bold;
  }
}
.footer-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  /deep/.el-button {
    width: 130px;
    white-space: normal;
    line-height: 20px;
    padding: 5px;
    font-size: 16px;
  }
}
.qt-footer-btn-PT,
.qt-footer-btn-EN {
  flex-direction: column;
  /deep/.el-button {
    width: 100%;
    margin-left: 0;
    margin-bottom: 20px;
  }
}
.question-tips-content {
  font-size: 18px;
  font-weight: bold;
}
</style>